import styled from '@emotion/styled';
import { colorPalettes } from '@linearb/linui-common';

export const StyledPageNotFound = styled.section`
  color: ${({ theme }) => colorPalettes[theme.palette.mode].text.primary};
  margin: auto;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  * {
    margin: 0;
  }

  h1 {
    font-style: normal;
    font-weight: 900;
    font-size: 3.0769rem;
    line-height: 150%;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 1.5385rem;
    line-height: 150%;
  }
`;
